import React from "react";
import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { useApp } from "@/state/AppContext";
import { WORKER_APP_URL } from "@/lib/appLinks";

/**
 * Where "Join as a worker" and any worker-only notification land. Workers are app-only (D1): they
 * sign up, go on duty, claim jobs and bid in the Business app, so the web explains that instead of
 * showing the citizen "hire a worker" form (which is what this CTA used to open).
 */
export default function JoinWorker() {
  const { t } = useApp();
  return (
    <div className="mx-auto max-w-xl px-5 py-16 sm:px-8" data-testid="join-worker-page">
      <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))]">
        <Smartphone size={22} />
      </span>
      <h1 className="mt-5 font-heading text-3xl font-bold tracking-tight">{t("joinWorker.title")}</h1>
      <p className="mt-3 text-muted-foreground" data-testid="join-worker-body">
        {t("joinWorker.body")}
      </p>
      <ul className="mt-5 list-disc space-y-1.5 pl-5 text-sm">
        <li>{t("joinWorker.stepOne")}</li>
        <li>{t("joinWorker.stepTwo")}</li>
        <li>{t("joinWorker.stepThree")}</li>
      </ul>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <a
          href={WORKER_APP_URL}
          data-testid="join-worker-app-link"
          className="inline-flex min-h-[44px] items-center rounded-full bg-[hsl(var(--primary))] px-5 text-sm font-semibold text-primary-foreground"
        >
          {t("joinWorker.getApp")}
        </a>
        <Link to="/services" data-testid="join-worker-hire-link" className="text-sm text-muted-foreground underline">
          {t("joinWorker.hireInstead")}
        </Link>
      </div>
    </div>
  );
}
